import {useContext, useEffect, Suspense} from 'react';
import {Container, Divider, makeStyles, useMediaQuery, useTheme} from '@material-ui/core';
import {AuthContext} from 'context/AuthContext';
import {ProfileContext} from 'context/ProfileContext';
import {Switch, Route} from 'react-router-dom';
import {privateRoutes, publicRoutes} from './router';
import PrivateRoute from 'components/routes/PrivateRoute';
import PublicRoute from 'components/routes/PublicRoute';
import NavBar from 'components/NavBar';
import Footer from 'components/Footer';
import Loading from 'components/Loading';
import NoMatch from './pages/publicPages/NoMatch';
import PasswordSetting from './pages/publicPages/PasswordSetting';
import services from 'services';
import {useLocation} from 'react-router-dom';
import clsx from 'clsx';
import './App.css';
import ContactUs from 'pages/privatePages/Search copy/components/ContactUs';

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh'
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		overflow: 'auto',
		background: '#FDFDFD'
	},
	container: {
		paddingTop: 5,
		paddingBottom: 5,
		flexGrow: 1,
		position: 'relative',
		paddingLeft: 50,
		paddingRight: 50,
		'& .MuiContainer-root': {
			padding: 0
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: 15,
			paddingRight: 15
		}
	},
	searchPage: {
		padding: 0
	}
}));

export let ROLE_TYPE = '';

interface AutocompleteTypes {
	value: string;
	name: string;
}

export const filterItems = (items: any) => {
	const filtered: AutocompleteTypes[] = [];
	items.map((item: AutocompleteTypes) => {
		if (
			filtered.filter((el: AutocompleteTypes) => el.name.toLowerCase() === item.name.toLowerCase())
				.length === 0
		) {
			filtered.push({name: item.name, value: item.value});
		}
	});
	return filtered;
};

function App() {
	const classes = useStyles();
	const theme = useTheme();
	const location = useLocation();
	const {state: authState} = useContext(AuthContext);
	const {dispatch: profileDispatch} = useContext(ProfileContext);
	const {state: profileState} = useContext(ProfileContext);

	// const filteredRoutes = privateRoutes.filter(el => el.role.includes(profileState.role));

	const ROLE =
		profileState.adminGroups && profileState.adminGroups !== '...'
			? profileState.adminGroups
			: profileState.role;
	const filteredRoutes = privateRoutes.filter(el => el.role.includes(ROLE));

	useEffect(() => {
		const userId = authState.userId;
		if (userId) {
			services.PRIVATE_SERVICES.AGENTS.getAgentsByID(userId).then(res => {
				profileDispatch({
					type: 'PROFILE',
					payload: res.result
				});
			});
		}
	}, [profileDispatch, authState.userId]);

	useEffect(() => {
		if (authState.isAuthenticated) {
			const params = {
				startDate: new Date().toISOString().substr(0, 10),
				endDate: new Date().toISOString().substr(0, 10)
			};
			services.PUBLIC_SERVICES.EXCHANGE.getExchangeRange(params).then(res => {
				profileDispatch({
					type: 'EXCHANGE',
					payload: res.result
				});
			});
		}
	}, [profileDispatch, authState.isAuthenticated]);

	useEffect(() => {
		ROLE_TYPE = ROLE;
	}, [profileState]);

	if (authState.isAuthenticated && !profileState.role) return <Loading />;

	return (
		<div className={classes.root}>
			{authState.isAuthenticated !== undefined ? (
				<>
					{authState.isAuthenticated ? (
						<>
							{/* {isAppBarVisible ? <AppBarComponent /> : null} */}
							<NavBar />
							{/* {location.pathname !== '/search' && <Breadcrumbs />} */}
						</>
					) : null}

					<main className={classes.content}>
						<Container
							maxWidth={false}
							className={clsx(
								classes.container,
								(location.pathname === '/search' || location.pathname === '/searchCopy') &&
									classes.searchPage
							)}>
							<Suspense fallback={<Loading />}>
								<Switch>
									{publicRoutes.map((route: any, i: number) => (
										<PublicRoute key={i} {...route} authState={authState} />
									))}
									{authState.isAuthenticated
										? filteredRoutes.map((route: any, i: number) => (
												<PrivateRoute key={i} {...route} authState={authState} />
										  ))
										: privateRoutes.map((route: any, i: number) => (
												<PrivateRoute key={i} {...route} authState={authState} />
										  ))}
									<Route path="/passwordSetting" component={PasswordSetting} />
									<Route component={NoMatch} />
								</Switch>
							</Suspense>
						</Container>
						{/* <Footer /> */}
						{authState.isAuthenticated && location.pathname === '/search' ? (
							<>
								<ContactUs />
								<Divider />
								<Footer />
							</>
						) : (
							<>
								<Divider />
								<Footer />
							</>
						)}
					</main>
				</>
			) : (
				<Loading />
			)}
		</div>
	);
}

export default App;
